import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    redText: {
      color: palette.danger.red,
      marginBottom: '10px',
      marginTop: '10px'
    },
    head: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px'
    },
    buttonsHead: {
      display: 'flex',
      gap: '20px',
      overFlowX: 'visible'
    },
    back: {
      transform: 'translateY(-10px)'
    },
    commandeNeedReminder: {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px 0'
    },
    commandeNeedReminderContent: {
      display: 'flex',
      width: '100%',
      gap: '10px',
      '& > div': {
        width: '90%'
      },
      '@media (max-width:375px)': {
        flexDirection: 'column',
        '& > div': {
          width: '100%'
        }
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
